import backendApi from '@/api/backendApi';
import { router } from '@/router'
import CryptoJS from 'crypto-js';
import moment from 'moment';

const SECRET = process.env.VUE_APP_ENCRYPT_KEY;

// Get token data from localStorage
try {
    const appPrefix = process.env.VUE_APP_PREFIX;
    const cipherToken = localStorage.getItem(appPrefix + 'token');

    // Decrypt
    var bytes = CryptoJS.AES.decrypt(cipherToken, SECRET);
    var token = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
} catch (err) {
    token = null;
}

const state = {
    status: {},
    token: token
};


const actions = {

    login({
        dispatch,
        commit
    }, {
        username,
        password
    }) {

        commit('loginRequest');
        dispatch('alert/clear', '', {
            root: true
        });

        backendApi.login(username, password)
            .then(
                token => {
                    commit('storeToken', token);

                    router.go('/');
                },
                error => {
                    dispatch('errorHandler', error);
                }
            );
    },

    logout({
        commit
    }) {
        // remove user, token from local storage to log user out
        const appPrefix = process.env.VUE_APP_PREFIX;
        localStorage.removeItem(appPrefix + 'token');

        commit('logout');
        // TODO: redirect to dashboard login
        // router.go('/login');
        const redirectUrl = process.env.VUE_APP_USER_DASHBOARD_URL;
        const port = window.location.port ? ':' + window.location.port : '';
        const ref = window.location.protocol + '//' + window.location.hostname + port
        window.location.href = redirectUrl + '/logout?ref=' + encodeURIComponent(ref);
    },

    updateToken({
        commit
    }, token) {
        commit('storeToken', token);
    },

    errorHandler({
        commit,
        dispatch
    }, error) {
        commit('loginFailure');

        try {
            dispatch('alert/error', error.response.data.message, {
                root: true
            });
        } catch (err) {
            dispatch('alert/error', "Oops, something went wrong.", {
                root: true
            });
        }


    }
};

const getters = {
    isLoggedIn: state => !!state.token,
    isTokenExpired: state =>  moment() > moment(state.token ? state.token.expires_at : null),
}

const mutations = {
    loginRequest(state) {
        state.status = {
            loggingIn: true
        };
    },
    storeToken(state, token) {
        token.expires_at = moment().add(token.expires_in, 'seconds');

        state.token = token;

        // store token and jwt token in local storage to keep user logged in between page refreshes
        // Encrypt
        const cipherToken = CryptoJS.AES.encrypt(JSON.stringify(token), SECRET).toString();
        const appPrefix = process.env.VUE_APP_PREFIX;
        localStorage.setItem(appPrefix + 'token', cipherToken);
    },
    loginFailure(state) {
        state.status = {};
        state.token = null;
    },
    logout(state) {
        state.status = {};
        state.token = null;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};